var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 16.5003V28.5003M15.9996 16.5003L12.6663 19.1669M15.9996 16.5003L19.333 19.1669M6.71162 12.6562C5.45057 12.9736 4.34879 13.7405 3.61329 14.8128C2.87779 15.8852 2.5592 17.1893 2.71737 18.48C2.87553 19.7707 3.49957 20.9592 4.47224 21.8223C5.44491 22.6853 6.69926 23.1635 7.99962 23.1669H9.33296",
    stroke: "#787878",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1066 10.0183C20.6508 8.21369 19.526 6.64991 17.9601 5.64394C16.3941 4.63796 14.5043 4.26505 12.6736 4.6008C10.8429 4.93655 9.20834 5.95584 8.1013 7.45204C6.99427 8.94825 6.49757 10.8094 6.71189 12.6583C6.71189 12.6583 6.91589 13.8343 7.33322 14.5009",
    stroke: "#787878",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6663 23.1673C23.6077 23.1667 24.5383 22.9667 25.3968 22.5805C26.2553 22.1943 27.0223 21.6306 27.6473 20.9266C28.2723 20.2226 28.7411 19.3943 29.0229 18.496C29.3046 17.5978 29.3929 16.6501 29.282 15.7152C29.1711 14.7804 28.8635 13.8797 28.3794 13.0723C27.8953 12.2649 27.2457 11.5692 26.4733 11.031C25.701 10.4928 24.8234 10.1243 23.8983 9.94966C22.9733 9.77506 22.0217 9.79834 21.1063 10.018L19.333 10.5006",
    stroke: "#787878",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.e11156587c7b50e22823b0f436c88f3e.svg";
export { ForwardRef as ReactComponent };